import Grid from './Grid';
import Blog from './Blog'


export default function Learn({ blogs }) {
  return (
    <section className=""
    >
      {/*<section>
        <Hero topTitle="Resource Hub" title="A powerful knowledge center tailored to help you navigate the world of data management." subtitle="Data Wisdom at Your Fingertips." />
  </section>*/}
      <h1 className='sr-only'>Learn</h1>
      <section className=' mt-4 '>
        <Grid />
      </section>

      <section className='mt-8'>
        <Blog blogs={blogs} />
      </section>

    </section>
  );
}
